export namespace IGetCategoryMetaTagsRequest {
  export enum PageType {
    PAGE_TYPE_UNKNOWN = 'PAGE_TYPE_UNKNOWN',
    DEFAULT = 'DEFAULT',
    SUPPLIERS = 'SUPPLIERS',
  }

  /**
   * Return an instance of IGetCategoryMetaTagsRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetCategoryMetaTagsRequest>
  ): IGetCategoryMetaTagsRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as IGetCategoryMetaTagsRequest;
}

export interface IGetCategoryMetaTagsRequest {
  /**
   * @deprecated
   */
  category_path_identifier: string | undefined;
  filter_keys: Array<string>;
  /**
   * @deprecated
   */
  page_type: keyof typeof IGetCategoryMetaTagsRequest.PageType | undefined;
}
